<div
    style=" background-color: #F3F3F5;width: 100%; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
    <button class="close-button" mat-dialog-close>
        <img src="./assets/images/close-icon.svg">
    </button>
</div>


<mat-dialog-content class="box-share-content">
    <div *ngIf="!errorMsg" class="main-box-title-32" style="margin-bottom: 25px ;">Confirm Remove List</div>
    <div *ngIf="errorMsg" class="main-box-title-32" style="margin-bottom: 25px ;">Cannot Remove List</div>
    <div>
        <div *ngIf="!errorMsg" class="main-box-title-18">Once you remove this list, you won’t be able to get them back. Please confirm
            that you want to proceed.</div>
        <div *ngIf="errorMsg" class="main-box-title-18"> This wordlist is currently linked to one or more projects and cannot be removed.<br>
 To proceed, you must first remove it from the following project(s):</div>
 <ul *ngIf="errorMsg" style="margin-left: 20px;">
    <li *ngFor="let proyecto of proyectos" class="main-box-title-18">
    {{ proyecto }}
    </li>
  </ul>
        <div style="margin-top: 40px;">
        </div>
    </div>

    <div class="box-button">
        <button class="cancel-btn" mat-dialog-close>
            <img class="cancel-img" src="./assets/images/yellow_icons/cancel-icon.svg">
            <span *ngIf="!errorMsg"><u class="main-box-value-16-bold">Cancel</u></span>
            <span *ngIf="errorMsg"><u class="main-box-value-16-bold">Close</u></span>
        </button>
        <button *ngIf="!errorMsg" class="analysis-button" (click)="deleteProyect()">
            <span class="main-box-title-16" style="font-weight: 600;">
                Remove List</span> </button>
    </div>
</mat-dialog-content>

